import { render, staticRenderFns } from "./staff-filters.vue?vue&type=template&id=1b2ff19e&"
import script from "./staff-filters.vue?vue&type=script&lang=js&"
export * from "./staff-filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports